import { RouteLocationNormalized } from 'vue-router';

export class hooks {
  protected data: unknown;
}
export interface hooksInterface {
  execute(to: RouteLocationNormalized, from: RouteLocationNormalized): void;
}
